import { Icon } from "@ingka/icon-webc/passive";
const generateDangerIcon = (prefixService, iconName) => {
  const iconTagName = `${prefixService.prefix}-${Icon.skapaTagName}`;
  const dangerButton = document.createElement(iconTagName);
  dangerButton.icon = iconName;
  return dangerButton;
};
export {
  generateDangerIcon
};
